<template>
  <div id="documentSearchTectonical">

    <main role="main">

      <div class="container">

        <div class="row mb-5">

          <div class="col-md-12">
            <h2 class="mb-3">
              <i class="far fa-file"></i>
              {{ $t('text.unclassifiedFilesReview.title') }}
            </h2>

            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="false"></loading>

            <div class="col-md-9 mt-4">

              <div class="row">

                <div class="col-md-12">
                  <b-breadcrumb class="mb-0">
                    <b-breadcrumb-item
                        v-for="(folder, index) in selectedFolderPath"
                        :key="'Folder_' + index"
                        :text="folder.name"
                        :active="folder.active"
                        @click="selectItem(folder)"
                    ></b-breadcrumb-item>
                  </b-breadcrumb>
                </div>

                <div class="col-md-12 bg-light p-3">


                  <ul class="directoryList py-0 px-0">
                    <li
                        class="fileList my-1"
                        v-for="folder in folders"
                        @click="selectItem(folder)">

                      <div class="hoverable px-3">
                        <span class="chevron-spacer"></span>
                        <div class="row">
                          <div class="col-md-1 text-center">
                            <i class="fas fa-folder fa-2x mt-2"></i>
                          </div>
                          <div class="col-md-11 pt-3">
                            {{ folder.name }}
                          </div>
                        </div>
                      </div>
                    </li>

                    <li
                        class="fileList my-1"
                        v-if="files.pagination && files.pagination.count > 0"
                        v-for="file in files.items"
                        @click="goToFile(file)">
                      <div class="hoverable px-3">
                        <span class="chevron-spacer"></span>
                        <div class="row">
                          <div class="col-md-1 text-center">
                            <i :class="$globalFunctions.getFileTypeIcon(file.mimetype)" class="fa-2x mt-2"></i>
                          </div>
                          <div class="col-md-11">
                            {{ file.name }}
                            <div><small
                                class="text-muted">{{ file.created ? moment(file.created).local().format('DD. MM. YYYY, HH:mm:ss') : '' }}</small>
                            </div>
                          </div>
                        </div>
                      </div>

                    </li>
                    <li v-if="(!files || (files.pagination && files.pagination.count === 0)) && (!folders || folders.length === 0)">
                      <span
                          class="chevron-spacer"></span><span><em>{{ $t('text.unclassifiedFilesReview.folderDoesNotContainSubfoldersOrFiles') }}.</em></span>
                    </li>
                  </ul>

                  <a
                      v-if="hasMoreItems"
                      @click="loadMoreItems"
                      class="btn btn-sm btn-link text-info ml-3"
                  ><i class="fa fa-download"></i
                  >{{ $t('text.unclassifiedFilesReview.loadMoreDocuments') }}</a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </main>

  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "UnclassifiedFilesReview",
  components: {
    Loading
  },
  data() {

    return {
      selectedFolderPath: [],
      folders: [],
      files: [],
      hasMoreItems: false,
      skipCount: 0,
      isLoading: false,
      totalRecords: null,
      page: 1,
      sort: [],
      perPage: 20,
      sortField: 'cm:created',
      sortAsc: false
    }
  },


  mounted() {
    const _this = this;

    if (this.$route.query.queryParams != null) {

      let unclassifiedFilesQueryObject = JSON.parse(atob(_this.$route.query.queryParams));
      _this.selectedFolderPath = unclassifiedFilesQueryObject.folderPath;
      _this.selectItem({id: unclassifiedFilesQueryObject.selectedId}, false);

    } else {

      _this.selectItem({id: '-evip-site-'}, false);

    }
  },

  beforeDestroy() {
    console.log("beforeDestroy");
    this.resetPagination();
  },

  methods: {

    resetPagination() {
      this.page = 1;
      this.skipCount = 0;
      this.hasMoreItems = false;
    },

    selectItem(node, appendResults) {
      const _this = this;

      console.log("node", node);

      if (node.id === '-evip-site-') {
        _this.selectedFolderPath = [
          {
            id: node.id,
            name: this.$t('text.globals.rootFolder'),
            active: true
          }
        ];
        _this.resetPagination();
      } else {
        if (!_.find(_this.selectedFolderPath, {id: node.id})) {
          _this.selectedFolderPath.push(
              {
                id: node.id,
                name: node.name,
                active: false
              });

          _.each(_this.selectedFolderPath, function (val, idx) {
            // console.log(val, idx);
            // console.log(val.id);
            // console.log(node.id);

            if (val.id !== node.id) {
              _this.selectedFolderPath[idx].active = false;
            } else {
              _this.selectedFolderPath[idx].active = true;
            }
          });
        }
      }

      _this.searchForDocuments(node.id, appendResults);

    },

    loadMoreItems() {
      console.log("HERE!!!!");
      const _this = this;
      // if(_this.skipCount === 0) {
      _this.skipCount = _this.skipCount + _this.perPage;
      // }

      let node = _.find(_this.selectedFolderPath, {active: true});

      _this.selectItem(node, true)
    },

    searchForDocuments(nodeId, appendResults) {
      const _this = this;

      if (!_this.$globalFunctions.checkForPermission('DOST_DOK_NEKLASIF')) {
        console.error("No permission for DOST_DOK_NEKLASIF");
        return
      }

      _this.isLoading = true;

      console.log("_this.skipCount", _this.skipCount);

      axios.get(config.rootAlfresco + '/alfresco/s/api/rma/admin/ehramba/evipFiles?nodeId=' + nodeId + '&flat=true&maxItems=' + _this.perPage + '&skipCount=' + _this.skipCount + '&sortField=cm:created&sortAsc=false')
          .then((res) => {
            console.log("API response", res.data);


            let unclassifiedFilesQueryObject = {
              selectedId: nodeId,
              folderPath: _this.selectedFolderPath
            }

            this.$router.replace({
              name: 'UnclassifiedFilesReview',
              query: {queryParams: btoa(JSON.stringify(unclassifiedFilesQueryObject))}
            }).catch(err => {
            });

            if (appendResults) {
              if (res.data.files.items) {
                _.each(res.data.files.items, function (file) {
                  _this.files.items.push(file);
                });
              }
            } else {
              _this.files = res.data.files;
            }

            _this.files.items = _.sortBy(
                _this.files.items,
                [
                  function (o) {
                    return o.created;
                  }
                ]
            ).reverse();


            //_this.skipCount = res.data.files && res.data.files.pagination ? (res.data.files.pagination.skipCount + _this.perPage) : 0;
            _this.folders = res.data.folders;
            _this.hasMoreItems = res.data.files && res.data.files.pagination ? res.data.files.pagination.hasMoreItems : false;
            _this.isLoading = false;


          })
          .catch((error) => {
            console.error(error);
            _this.isLoading = false;
          });

    },

    goToFile(file) {
      const _this = this;
      _this.isLoading = true;
      _this.$router.push({name: 'DocumentDetails', params: {id: file.id}});
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/UnclassifiedFilesReview.vue